class SectionId {
  private static readonly separator = '__';

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId: string): string {
    return qualifiedSectionId.split(SectionId.separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId: string): string {
    return qualifiedSectionId.split(SectionId.separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId: string, sectionName: string): string {
    return `${sectionId}${SectionId.separator}${sectionName}`;
  }
}

export { SectionId };
